// extracted by mini-css-extract-plugin
export default {"container":"_1LZCCx","title":"_2NsMog","timeContainer":"_2wrc85","timeValue":"_3H_IlO","timeLabel":"_2R7r6h","timeSecond":"_21hnUr"};